import React from 'react';

import utils, { statuses } from './Utils';
import VideoToCanvas from './VideoToCanvas';
import ReactPlayer from 'react-player';
import RequestDeleteModal from './RequestDeleteModal'
import RequestReviewModal from './RequestReviewModal'
import DeepfakeSVG from '../images/deepfake.inline.svg';
import CleanSVG from '../images/clean.inline.svg';
import Tooltip from "react-bootstrap/Tooltip";
import Button from "react-bootstrap/Button";
import Popover from "react-bootstrap/Popover";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import warning_adult from '../images/warning_adult_n.png';

const DetailRow = (props) => {
  return (
    <div className="col-xs-12">
      <div className="col-sm-6 p-0">
        <label style={{ textTransform: 'capitalize' }}>{props.title}:</label>
      </div>
      <div className="col-sm-6 p-0">
        <p className="semi-light font-13 m-b-10">
          {props.text ? props.text : '-'}
        </p>
      </div>
    </div>
  );
};


function getText(title) {

  let url = ""
  let text = ""
  if (title === "Ensemble") {
    text = "Combines the power of deepware scanner and seferbekov's scanner"

  }
  if (title === "seferbekov") {
    url = "https://github.com/selimsef/dfdc_deepfake_challenge/blob/master/README.md"
    text = "Best performing single model selected from seferbekov's ensemble. Only the weights were used, our deepware scanner produces results."
  }


  if (title === "Analyst") {
    text = "Scored by the analyst."
  }

  return (
    <div>
      <p>{text}</p>
      {title === "seferbekov" ?
        <a target="_blank" href={`${url}`} style={{ textDecoration: 'underline', cursor: 'pointer' }}>Github</a>
        : ""
      }
    </div>
  );
}

const DetailModelRow = (props) => {

  let color = utils.getColorbyStatus(props.status);
  let iconStyle = { color: color, fill: color };
  return (
    <div className="col-xs-12">
      <div className="col-xs-12 col-md-4 p-0 h35 font-13">
        {/* <label style={{ textTransform: 'capitalize' }}>
          {props.title}:</label> */}

        {props.title != "deepware" ?
          <OverlayTrigger
            trigger="click"
            key={props.title}
            placement={'right'}
            rootClose
            overlay={
              <Popover id={`popover-positioned-${props.title}`}>
                <Popover.Title as="h3" style={{ textTransform: 'capitalize' }}>{props.title}</Popover.Title>
                <Popover.Content>
                  {getText(props.title)
                  }
                </Popover.Content>
              </Popover>
            }
          >
            <label style={{ textTransform: 'capitalize', textDecoration: 'underline', cursor: 'pointer' }}>
              {props.title}:</label>
          </OverlayTrigger>
          : <a href="https://github.com/deepware/deepfake-scanner/blob/main/deepware.md" target="_blank"> <label style={{ textTransform: 'capitalize', textDecoration: 'underline', cursor: 'pointer' }}>
            {props.title}:</label></a>}
      </div>
      <div className="col-xs-12 col-md-8 p-0 h35 font-12">
        <label className=" font-12 " style={iconStyle}>
          {props.text ? props.text : '-'}
          {props.title != "Analyst" && props.title != "analyst" ? "(" + props.score + "%)" : ""}
        </label>
      </div>

      {/* <div className="hidden-xs col-md-2 p-0 h35 font-13">
        <label className="semi-light font-13 " style={{  color: color,paddingTop:'2px'}}>({props.score}%)</label>
      </div> */}
    </div>
  );
};

const StatusIcon = ({ status }) => {
  let color = utils.getColorbyStatus(status);
  let iconStyle = { color: color, fill: color, maxHeight: '17px ', marginTop: '3px' };
  switch (status) {
    case statuses.DEEPFAKE:
      return (
        <DeepfakeSVG
          className="col-xs-1 col-md-12 p-0 "
          style={iconStyle}
        ></DeepfakeSVG>
      );

    case statuses.SUSPICIOUS:
      return (
        <DeepfakeSVG
          className="col-xs-1 col-md-12 p-0"
          style={iconStyle}
        ></DeepfakeSVG>
      );
    case statuses.CLEAN:
      return (
        <CleanSVG className="col-xs-1 col-md-12  p-0" style={iconStyle}></CleanSVG>
      );
    default:
      return null;
  }
};


function getModel(report, threshold) {

  var arrResults = Object.keys(report?.results);


  var analystOk = false;
  if (arrResults.includes("analyst")) {
    analystOk = true;
  }

  const Results = arrResults.map((arrResult) => {

    if (arrResult.toString() != "final") {
      if (analystOk == true) {
        if (arrResult.toString() != "Analyst") {

          return (
            <DetailModelRow

              status={utils.getStatusByValue(report?.results[arrResult]?.score, threshold)}
              title={arrResult}
              score={report?.results[arrResult]?.score}
              text={utils.getStatusText(utils.getStatusByValue(report?.results[arrResult]?.score, threshold), report)}
            />
          )
        }
      }
      else {

        return (
          <DetailModelRow
            status={utils.getStatusByValue(report?.results[arrResult]?.score, threshold)}
            title={arrResult}
            score={report?.results[arrResult]?.score}
            text={utils.getStatusText(utils.getStatusByValue(report?.results[arrResult]?.score, threshold), report)}
          />

        )

      }

    }
  }
  );
  if (arrResults.length > 1 & report?.results["final"] !== undefined) {

    Results.push(
      <DetailModelRow status={utils.getStatusByValue(report?.results["final"]?.score, threshold)}
        title="Ensemble"
        score={report?.results["final"]?.score}
        text={utils.getStatusText(utils.getStatusByValue(report?.results["final"]?.score, threshold), report)}
      />
    );
  }

  return (
    <div>{Results}</div>
  );
}

const DetailsPanel = (props) => {
  var videoUrl = "";
  var videoThumbnail = "";
  var isAdult = true;
  if (props.info?.tags?.adult?.nudity || props.info === null) {
    if (props.anlystTokenOK == false) {
      videoUrl = ""
      videoThumbnail = warning_adult;
      isAdult = props.info?.tags?.adult?.nudity;
    } else {
      videoUrl = utils.getVideoURL(props.report?.['video-id']);
      videoThumbnail = utils.getVideoThumbnailURL(props.report?.['video-id']);
      isAdult = props.info?.tags?.adult?.nudity;

    }


  }
  else {
    videoUrl = utils.getVideoURL(props.report?.['video-id']);
    videoThumbnail = utils.getVideoThumbnailURL(props.report?.['video-id']);
    isAdult = props.info?.tags?.adult?.nudity;
  }



  return (
    <div className="panel panel-default detail-panel col-xs-12 flex">
      <div className="panel-heading sm col-xs-12 text-center">
        <div className="col-xs-12 m-y-auto text-center">DETAILS</div>
      </div>

      <div className="panel-body col-xs-12">
        <div className="col-xs-12 col-md-12 checkSpan">
          <p style={{ textAlign: 'center', fontWeight: '500' }} className="sBeta">
            {/* <a href="https://github.com/deepware/deepfake-scanner"
              target="_blank"
              className="aBeta"
            >Deepware Scanner is still in Beta</a> */}

Deepware aims to give an opinion about the scanned video and is not responsible for the result. 
As Deepware Scanner is still in beta, the results should not be treated as an absolute truth or evidence. 
            </p>
        </div>


        {props.frameData?.frames != null ?

          <div className="col-xs-12 col-md-12 ">
            <VideoToCanvas
              src={
                videoUrl
                // props.info?.tags?.adult?.nudity || props.info === null ?
                //   "" :
                //   utils.getVideoURL(props.report?.['video-id'])
              }
              width={props.info?.metadata?.video?.width}
              height={props.info?.metadata?.video?.height}
              fps={props.info?.metadata?.video?.frame_rate}
              frames={props.frameData?.frames}
              resultInfo={props.frameData?.result_info}
              frameWidth={props.info?.metadata?.video?.width}
              frameHeight={props.info?.metadata?.video?.height}
              thumbnail={
                videoThumbnail
                // props.info?.tags?.adult?.nudity || props.info === null ?
                //   warning_adult :
                //   utils.getVideoThumbnailURL(props.report?.['video-id'])
              }
              isOk={props.report?.completed}
              isAdult={isAdult}
              anlystTokenOK={props.anlystTokenOK}
            />

          </div>
          :


          <div className="col-xs-12 col-md-12 ">

            <div className="embed-responsive embed-responsive-16by9 "
              style={{ backgroundColor: '#000' }}
            >
              <ReactPlayer
                className="analyzed-video"
                url={
                  videoUrl
                  // props.info?.tags?.adult?.nudity || props.info === null ?
                  // "" :
                  // utils.getVideoURL(props.report?.['video-id'])
                }
                playing={false}
                width="100%"
                height="100%"
                // loop={faces}
                controls={true}
                playbackRate={1}
                playsinline={true}
                volume={0.1}
                muted={true}
              />
            </div>
          </div>

        }

        <div className="col-xs-12 col-md-12  m-b-30">

        </div>
        {props.status != "8" ?
        <div className="col-sm-12 col-md-4">
          <div className="col-xs-12">
            <h3 className="m-t-10 m-b-5 fweight-600">Model Results</h3>
          </div>
          {/* <div className="clearfix"></div> */}
          <hr className="m-t-10" />
          {
            getModel(props.report, props.threshold)
          }


        </div>
        :""
}
        <div className="col-sm-12 col-md-4">
          <div className="col-xs-12">
            <h3 className="m-t-10 m-b-5 fweight-600">Video</h3>
          </div>
          {/* <div className="clearfix"></div> */}
          <hr className="m-t-10" />
          <DetailRow
            title="Duration"
            text={utils.fmtSec(props.info?.metadata?.video?.duration)}
          />
          <DetailRow
            title="Resolution"
            text={utils.resolution(
              props.info?.metadata?.video?.width,
              props.info?.metadata?.video?.height
            )}
          />
          <DetailRow
            title="Frame Rate"
            text={utils.fmtFrameRate(props.info?.metadata?.video?.frame_rate)}
          />
          <DetailRow title="Codec" text={props.info?.metadata?.video?.codec} />
        </div>
        <div className="col-sm-12 col-md-4">
          <div className="col-xs-12">
            <h3 className="m-t-10 m-b-5 fweight-600">Audio</h3>
          </div>
          {/* <div className="clearfix"></div> */}
          <hr className="m-t-10" />
          <DetailRow
            title="Duration"
            text={utils.fmtSec(props.info?.metadata?.audio?.duration)}
          />
          <DetailRow
            title="Channel"
            text={props.info?.metadata?.audio?.channel}
          />
          <DetailRow
            title="Sample Rate"
            text={utils.fmtSampleRate(props.info?.metadata?.audio?.sample_rate)}
          />
          <DetailRow title="Codec" text={props.info?.metadata?.audio?.codec} />
        </div>
        <div className="col-xs-12">
          <hr className="m-t-10" />
          <div className="col-xs-12 btn-group-sm divButton">
            <RequestReviewModal reportId={props.report?.['report-id']} />
            <RequestDeleteModal reportId={props.report?.['report-id']} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DetailsPanel;
